/* @flow */
import { List, Map, OrderedMap, fromJS } from 'immutable';
import { combineReducers } from 'redux-immutable';
import type { Action } from 'trustar/utils/redux-types.js';
import { toLower } from 'trustar/utils';

import { listToOrderedMap, listToTextMap } from './constants.js';
import {
  SET_CURRENT_CATEGORY_ID,

  FETCH_SUCCESS,
  SAVE_SUCCESS,
  DELETE_SUCCESS,

  UPLOAD_REDACTION_FILE,
  BULK_SAVE,
  BULK_SAVE_SUCCESS,
  BULK_SAVE_FAILURE,

  FETCH_REDACTABLES_SUCCESS,
  CLEAR_REDACTABLES,
} from './action-types.js';

/* Loading is true until we determine the library type and fetch initial terms */
export const loading = (state: boolean = true, action: Action<*>) => {
  const { type } = action;
  switch(type) {
  case FETCH_SUCCESS:
    return false;
  default:
    return state;
  }
};

export const currentCategoryId = (state: number = 1, action: Action<*>) => {
  switch (action.type) {
  case SET_CURRENT_CATEGORY_ID:
    return action.payload;
  default:
    return state;
  }
};

/* The full map of redaction terms for this user */
export const terms = (state: OrderedMap<any, any> = OrderedMap(), action: Action<*>) => {
  const { type, payload } = action;

  switch (type) {
  case FETCH_SUCCESS:
    return listToOrderedMap(payload);
  case SAVE_SUCCESS:
    return state.merge(listToOrderedMap(payload));
  case DELETE_SUCCESS:
    return state.delete(payload.get('id'));
  default:
    return state;
  }
};

/* This store is simply used as a text-only map of all redaction terms
 * to quickly see if a term already exists */
export const termsTextMap = (state: Map<*, *> = Map(), action: Action<*>) => {
  const { type, payload } = action;

  switch (type) {
  case FETCH_SUCCESS:
    return listToTextMap(payload);
  case SAVE_SUCCESS:
    return state.merge(listToTextMap(payload));
  case DELETE_SUCCESS:
    return state.delete(toLower(payload.get('text')));
  default:
    return state;
  }
};

export const status = (state: string = 'READY', action: Action<*>) => {
  switch (action.type) {
  case UPLOAD_REDACTION_FILE:
    return 'UPLOADING';
  case BULK_SAVE:
    return 'IMPORTING';
  case BULK_SAVE_SUCCESS:
  case BULK_SAVE_FAILURE:
    return 'READY';
  default:
    return state;
  }
};

/* This store holds the redactables that we fetch from the server. This store is used
 * to check whether an un-redacted term was originally a redactable. */
export const allRedactables = (state: List<any> = List(), action: Action<*>) => {
  switch (action.type) {
  case FETCH_REDACTABLES_SUCCESS:
    return fromJS(action.payload);
  default:
    return state;
  }
};

export const redactables = (state: List<any> = List(), action: Action<*>) => {
  const { type, payload } = action;

  switch (type) {
  case FETCH_REDACTABLES_SUCCESS:
    return fromJS(payload);
  case CLEAR_REDACTABLES:
    return List();
  case DELETE_SUCCESS:
    return state
      .toKeyedSeq() // Why do this conversion?
      .filter(v => v.get('text').search(new RegExp(payload.text, 'gi')) < 0)
      .toList();
  default:
    return state;
  }
};

export default combineReducers({
  loading,
  currentCategoryId,
  terms,
  termsTextMap,
  status,
  allRedactables,
  redactables,
});



// WEBPACK FOOTER //
// ./src/app/modules/redaction/stores.js